import type { SVGProps } from 'react';

export const Plus = (props: SVGProps<any>) => (
  <svg
    height="32px"
    role="img"
    viewBox="0 0 32 32"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{'plus-icon'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g fill={props.fill} fillRule="nonzero">
        <g>
          <polygon points="17.7421603 14.2547355 17.7421603 0 14.2578397 0 14.2578397 14.2547355 0 14.2547355 0 17.7382974 14.2578397 17.7382974 14.2578397 32 17.7421603 32 17.7421603 17.7382974 32 17.7382974 32 14.2547355"></polygon>
        </g>
      </g>
    </g>
  </svg>
);
